// extracted by mini-css-extract-plugin
module.exports = {"container":"Heart_container__24hs2","heart":"Heart_heart__JeHpe","mainPadOnHeart":"Heart_mainPadOnHeart__1AKzq"};